export default "20260923.2 \r\n"